import { z } from "zod";
import { ChoiceOptionsSchema, defineControl, placeholderFieldSchema, } from "./field.js";
// Several options chosen from one list. The placeholder is what its search box
// shows before anything is typed. Two options to start with, named and valued
// for their place, as the single-selection drop-down has.
export const dropdownMulti = defineControl({
    key: "dropdownMulti",
    label: "Drop-down multi selection",
    schema: placeholderFieldSchema("dropdownMulti").extend(ChoiceOptionsSchema.shape),
    answer: z.string().array(),
    isClearable: true,
    empty: {
        placeholder: "",
        required: false,
        options: [
            { label: "Option 1", value: "option-1" },
            { label: "Option 2", value: "option-2" },
        ],
    },
});
